

// import React, { useState, useEffect } from 'react';
// import { ref, get } from 'firebase/database';
// import { database } from '../firebase';
// import { Line, Pie } from 'react-chartjs-2';
// import { Chart, registerables } from 'chart.js';
// import { useAuth } from '../AuthContext';

// import MediaUploader from './MediaUploader';
// import AdminSlider from './AdminSlider';
// import AddParentForm from './AddParentForm';
// import OrderDocumentsTable from './OrderDocumentsTable';

// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// // import EnquiryManagement from './EnquiryManagement';
// Chart.register(...registerables);




// const AdminDashboard = () => {
//   const [activeTab, setActiveTab] = useState('dashboard');
//   const [products, setProducts] = useState([]);
//   const [orders, setOrders] = useState([]);
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [stats, setStats] = useState({});
//   // Inside your AdminDashboard component, add these hooks at the top:
// // const { logout } = useAuth();
// const navigate = useNavigate();
// const { logout } = useAuth();

// // const handleLogout = () => {
// //   logout();
// //   toast.success('Logged out successfully');
// //   navigate('/login');
// // };

// const handleLogout = () => {
//   localStorage.removeItem('adminAuth');
//   navigate('/');
// };

// // Add this useEffect to your AdminDashboard component
// // useEffect(() => {
// //   const checkAuth = () => {
// //     const token = localStorage.getItem('authToken');
// //     const userData = JSON.parse(localStorage.getItem('userData'));
    
// //     if (!token || !userData || !userData.isAdmin) {
// //       // logout();
// //       navigate('/login');
// //     }
// //   };

// //   // Check auth on component mount
// //   checkAuth();

// //   // Set up beforeunload to prevent back navigation issues
// //   window.addEventListener('beforeunload', checkAuth);
  
// //   return () => {
// //     window.removeEventListener('beforeunload', checkAuth);
// //   };
// // }, [ navigate]);



//   useEffect(() => {
//     fetchAllData();
//   }, []);

//   const fetchAllData = async () => {
//     try {
//       setLoading(true);
      
//       // Fetch products
//       const productsRef = ref(database, 'photoshop/admin/categories');
//       const productsSnapshot = await get(productsRef);
//       let productsData = [];
//       productsSnapshot.forEach(category => {
//         category.forEach(owner => {
//           owner.forEach(size => {
//             productsData.push({
//               id: `${owner.key}-${size.key}`,
//               category: category.key,
//               owner: owner.key,
//               size: size.key,
//               ...size.val()
//             });
//           });
//         });
//       });
//       setProducts(productsData);

//       // Fetch orders
//       const ordersRef = ref(database, 'photoshop/admin/orders');
//       const ordersSnapshot = await get(ordersRef);
//       const ordersData = ordersSnapshot.val() || {};
//       setOrders(ordersData);

//       // Fetch users
//       const usersRef = ref(database, 'photoshop/customers');
//       const usersSnapshot = await get(usersRef);
//       setUsers(usersSnapshot.val() || []);

//       // Calculate stats - ONLY REVENUE CALCULATION CHANGED
//       setStats({
//         totalProducts: productsData.length,
//         totalOrders: Object.keys(ordersData).length,
//         totalUsers: Object.keys(usersSnapshot.val() || {}).length,
//         revenue: Object.values(ordersData).reduce((sum, order) => sum + (order.total || 0), 0)
//       });

  

//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       setLoading(false);
//     }
//   };

 



//   return (
//     <div style={{ 
//         display: 'flex', 
//         minHeight: '100vh', 
//         background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
//         fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
//         overflow: 'hidden' // Prevent double scroll
        
//     }}>
//       {/* Fixed Sidebar */}
//       <div style={{
//         width: '280px',
//         background: 'linear-gradient(180deg, #2874f0 0%, #1a5dc8 100%)',
//         color: 'white',
//         padding: '20px 0',
//         boxShadow: '2px 0 10px rgba(0,0,0,0.1)',
//         position: 'fixed',
//         height: '100vh',
//         zIndex: 100,
        
//       }}>
//         <div style={{ 
//             padding: '0 20px 20px', 
//             borderBottom: '1px solid rgba(255,255,255,0.2)',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '10px'
//         }}>
//           <div style={{
//             width: '40px',
//             height: '40px',
//             background: 'rgba(255,255,255,0.2)',
//             borderRadius: '8px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             fontSize: '20px'
//           }}>🛒</div>
//           <h2 style={{ 
//               margin: 0,
//               fontSize: '20px',
//               fontWeight: 600,
//               background: 'linear-gradient(to right, #fff 0%, #d1e0ff 100%)',
//               WebkitBackgroundClip: 'text',
//               WebkitTextFillColor: 'transparent'
//           }}>Admin Panel</h2>
//         </div>
//         <nav>
//           <ul style={{ listStyle: 'none', padding: 0, marginTop: '20px' }}>
//             {[
//               { id: 'dashboard', icon: '📊', label: 'Dashboard' },
//               { id: 'Gallery', icon: '🛍️', label: 'Gallery' },
//               { id: 'CBSE', icon: '📦', label: 'CBSEDisclosures' },
//               // { id: 'users', icon: '👥', label: 'Users' },
//               {id: 'sliders', icon: '🖼️', label: 'Sliders'},
//               { id: 'addparent', icon: '⚙️', label: 'Add Parents' },
//             ].map(item => (
//               <li 
//                 key={item.id}
//                 style={{
//                   padding: '14px 20px',
//                   cursor: 'pointer',
//                   background: activeTab === item.id ? 'rgba(255,255,255,0.25)' : 'transparent',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: '12px',
//                   transition: 'all 0.3s ease',
//                   position: 'relative',
//                   overflow: 'hidden',
//                   ':hover': {
//                     background: 'rgba(255,255,255,0.15)'
//                   },
//                   '::after': activeTab === item.id ? {
//                     content: '""',
//                     position: 'absolute',
//                     right: 0,
//                     top: 0,
//                     height: '100%',
//                     width: '4px',
//                     background: 'white',
//                     borderRadius: '4px 0 0 4px'
//                   } : {}
//                 }}
//                 onClick={() => setActiveTab(item.id)}
//               >
//                 <span style={{
//                   fontSize: '18px',
//                   transition: 'transform 0.3s ease',
//                   transform: activeTab === item.id ? 'scale(1.2)' : 'scale(1)'
//                 }}>{item.icon}</span>
//                 <span style={{
//                   fontWeight: activeTab === item.id ? 600 : 400,
//                   transition: 'all 0.3s ease'
//                 }}>{item.label}</span>
//                 {activeTab === item.id && (
//                   <span style={{
//                     marginLeft: 'auto',
//                     fontSize: '12px',
//                     background: 'rgba(255,255,255,0.3)',
//                     padding: '2px 8px',
//                     borderRadius: '10px'
//                   }}>Active</span>
//                 )}
//               </li>
//             ))}
//           </ul>
//         </nav>
//       </div>

//       {/* Scrollable Main Content */}
//       <div style={{ 
//           flex: 1, 
//           padding: '30px',
//           marginLeft: '280px', // Match sidebar width
//           overflowY: 'hidden',

       
          
//       }}>
//         <div style={{
//   display: 'flex',
//   justifyContent: 'space-between',
//   alignItems: 'center',
//   marginBottom: '30px',
//   paddingBottom: '20px',
//   borderBottom: '1px solid rgba(0,0,0,0.1)'
// }}>
//   <h1 style={{ 
//       margin: 0,
//       fontSize: '28px',
//       fontWeight: 700,
//       color: '#1a237e',
//       position: 'relative',
//       '::after': {
//         content: '""',
//         position: 'absolute',
//         bottom: '-10px',
//         left: 0,
//         width: '50px',
//         height: '4px',
//         background: 'linear-gradient(90deg, #2874f0, #1a5dc8)',
//         borderRadius: '2px'
//       }
//   }}>
//     {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
//   </h1>
  
//   <button
//     onClick={handleLogout}
//     style={{
//       background: 'linear-gradient(135deg, #ff5252, #ff1744)',
//       color: 'white',
//       border: 'none',
//       padding: '10px 20px',
//       borderRadius: '8px',
//       cursor: 'pointer',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '8px',
//       transition: 'all 0.3s ease',
//       fontSize: '14px',
//       fontWeight: 500,
//       boxShadow: '0 2px 10px rgba(255, 82, 82, 0.3)',
//       ':hover': {
//         transform: 'translateY(-2px)',
//         boxShadow: '0 4px 15px rgba(255, 23, 68, 0.4)',
//         background: 'linear-gradient(135deg, #ff1744, #ff5252)'
//       }
//     }}
//   >
//     Logout
//     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//       <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
//       <path d="M16 17l5-5-5-5" />
//       <path d="M21 12H9" />
//     </svg>
//   </button>
// </div>

//         {loading ? (
//           <div style={{ 
//               textAlign: 'center', 
//               padding: '60px',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               justifyContent: 'center'
//           }}>
//             <div style={{
//               width: '60px',
//               height: '60px',
//               border: '5px solid rgba(40, 116, 240, 0.2)',
//               borderTopColor: '#2874f0',
//               borderRadius: '50%',
//               animation: 'spin 1s linear infinite',
//               marginBottom: '20px',
//               '@keyframes spin': {
//                 'to': { transform: 'rotate(360deg)' }
//               }
//             }}></div>
//             <h3 style={{ color: '#555', margin: 0 }}>Loading Dashboard...</h3>
//           </div>
//         ) : (
//           <>
//             {activeTab === 'dashboard' && (
//               <div>

// {/* <div style={{ 
//   display: 'grid', 
//   gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', 
//   gap: '20px', 
//   marginBottom: '30px'
// }}>
//   {[
//     { 
//       title: 'Total Products', 
//       value: stats.totalProducts, 
//       icon: '🛍️', 
//       color: '#2874f0',
//       previous: previousStats.totalProducts
//     },
//     { 
//       title: 'Total Orders', 
//       value: stats.totalOrders, 
//       icon: '📦', 
//       color: '#ff9f00',
//       previous: previousStats.totalOrders
//     },
//     { 
//       title: 'Total Users', 
//       value: stats.totalUsers, 
//       icon: '👥', 
//       color: '#fb641b',
//       previous: previousStats.totalUsers
//     },
//     { 
//       title: 'Total Revenue', 
//       value: `₹${stats.revenue.toLocaleString('en-IN')}`, 
//       icon: '💰', 
//       color: '#8e24aa',
//       previous: previousStats.revenue
//     }
//   ].map((stat, index) => {
//     const { change, direction } = calculatePercentageChange(stat.value, stat.previous);
//     const isPositive = direction === '↑';
    
//     return (
//       <div key={index} style={{
//         background: 'linear-gradient(135deg, white 0%, #f8f9fd 100%)',
//         borderRadius: '12px',
//         padding: '25px',
//         boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         transition: 'all 0.3s ease',
//         position: 'relative',
//         overflow: 'hidden',
//         ':hover': {
//           transform: 'translateY(-5px)',
//           boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
//         },
//         '::before': {
//           content: '""',
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '5px',
//           background: stat.color
//         }
//       }}>
//         <div>
//           <div style={{ 
//               color: '#666', 
//               fontSize: '14px',
//               fontWeight: 500,
//               marginBottom: '5px'
//           }}>{stat.title}</div>
//           <div style={{ 
//               fontSize: '28px', 
//               fontWeight: 'bold', 
//               margin: '8px 0',
//               color: '#333'
//           }}>{stat.value}</div>
//           <div style={{
//             fontSize: '12px',
//             color: '#888',
//             display: 'flex',
//             alignItems: 'center',
//             gap: '5px'
//           }}>
//             <span style={{ 
//                 color: isPositive ? '#4CAF50' : '#F44336',
//                 fontWeight: 600
//             }}>
//               {direction} {change}% from last month
//             </span>
//           </div>
//         </div>
//         <div style={{
//           width: '60px',
//           height: '60px',
//           borderRadius: '50%',
//           background: `${stat.color}20`,
//           color: stat.color,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           fontSize: '24px',
//           transition: 'all 0.3s ease',
//           ':hover': {
//             transform: 'scale(1.1) rotate(10deg)'
//           }
//         }}>
//           {stat.icon}
//         </div>
//       </div>
//     );
//   })}
// </div> */}

//               </div>
//             )}
//             {activeTab === 'Gallery' && <MediaUploader/>}
//             {activeTab === 'sliders' && <AdminSlider/>}
//             {activeTab === 'addparent' && <AddParentForm/>}
//             {activeTab === 'CBSE' && <OrderDocumentsTable />}
//             {/*         
//             {activeTab === 'users' && <UserManagement/>}
//             {activeTab === 'sliders' && <AdminSlider/>}
//              */}
//           </>
//         )}
//       </div>
//       <style>{`
//   .users-table-wrapper {
//     background: white;
//     border-radius: 12px;
//     overflow: hidden;
//     box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
//     max-height: 600px; /* Set maximum height for scroll */
//     overflow-y: auto; /* Enable vertical scrolling */
//   }

//   .users-table {
//     width: 100%;
//     border-collapse: collapse;
//     position: relative;
//   }

//   .users-table thead {
//     position: sticky;
//     top: 0;
//     z-index: 1;
//     background: #f1f5f9;
//   }

//   .users-table th {
//     background: #f1f5f9;
//     padding: 1rem 1.5rem;
//     text-align: left;
//     font-weight: 600;
//     color: #334155;
//     font-size: 0.875rem;
//     text-transform: uppercase;
//     letter-spacing: 0.05em;
//     position: sticky;
//     top: 0;
//     box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
//   }

//   .users-table tbody {
//     overflow-y: auto;
//   }

//   /* Keep existing styles, add these modifications */
//   .users-table tr {
//     display: table;
//     width: 100%;
//     table-layout: fixed;
//   }

//   .users-table td {
//     padding: 1.25rem 1.5rem;
//     border-bottom: 1px solid #f1f5f9;
//     color: #334155;
//     transition: background 0.2s;
//     background: white;
//   }
// `}</style>
//     </div>
//   );
// };

// export default AdminDashboard;













import React, { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { database } from '../firebase';
import { Line, Pie } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import { useAuth } from '../AuthContext';
import MediaUploader from './MediaUploader';
import AdminSlider from './AdminSlider';
import AddParentForm from './AddParentForm';
import OrderDocumentsTable from './OrderDocumentsTable';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import AcademicAdminDashboard from './AcademicAdminDashboard';
import Notification from './Notification';

Chart.register(...registerables);

const AdminDashboard = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [products, setProducts] = useState([]);
  const [orders, setOrders] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({});
  const navigate = useNavigate();
  const { auth, logout } = useAuth();

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!auth) {
      navigate('/'); // Redirect to login page
    }
  }, [auth, navigate]);

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/'); // Redirect to login page
  };

  useEffect(() => {
    if (auth) { // Only fetch data if authenticated
      fetchAllData();
    }
  }, [auth]); // Add auth as dependency

  const fetchAllData = async () => {
    try {
      setLoading(true);
      
      // Fetch products
      const productsRef = ref(database, 'photoshop/admin/categories');
      const productsSnapshot = await get(productsRef);
      let productsData = [];
      productsSnapshot.forEach(category => {
        category.forEach(owner => {
          owner.forEach(size => {
            productsData.push({
              id: `${owner.key}-${size.key}`,
              category: category.key,
              owner: owner.key,
              size: size.key,
              ...size.val()
            });
          });
        });
      });
      setProducts(productsData);

      // Fetch orders
      const ordersRef = ref(database, 'photoshop/admin/orders');
      const ordersSnapshot = await get(ordersRef);
      const ordersData = ordersSnapshot.val() || {};
      setOrders(ordersData);

      // Fetch users
      const usersRef = ref(database, 'photoshop/customers');
      const usersSnapshot = await get(usersRef);
      setUsers(usersSnapshot.val() || []);

      // Calculate stats
      setStats({
        totalProducts: productsData.length,
        totalOrders: Object.keys(ordersData).length,
        totalUsers: Object.keys(usersSnapshot.val() || {}).length,
        revenue: Object.values(ordersData).reduce((sum, order) => sum + (order.total || 0), 0)
      });

      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
      toast.error('Failed to fetch data');
    }
  };

  if (!auth) {
    return null; // or a loading spinner while redirect happens
  }



  return (
    <div style={{ 
        display: 'flex', 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%)',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
        overflow: 'hidden' // Prevent double scroll
        
    }}>
      {/* Fixed Sidebar */}
      <div style={{
        width: '280px',
        background: 'linear-gradient(180deg, #2874f0 0%, #1a5dc8 100%)',
        color: 'white',
        padding: '20px 0',
        boxShadow: '2px 0 10px rgba(0,0,0,0.1)',
        position: 'fixed',
        height: '100vh',
        zIndex: 100,
        
      }}>
        <div style={{ 
            padding: '0 20px 20px', 
            borderBottom: '1px solid rgba(255,255,255,0.2)',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            background: 'rgba(255,255,255,0.2)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px'
          }}>🛒</div>
          <h2 style={{ 
              margin: 0,
              fontSize: '20px',
              fontWeight: 600,
              background: 'linear-gradient(to right, #fff 0%, #d1e0ff 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
          }}>Admin Panel</h2>
        </div>
        <nav>
          <ul style={{ listStyle: 'none', padding: 0, marginTop: '20px' }}>
            {[
              // { id: 'dashboard', icon: '📊', label: 'Dashboard' },
              { id: 'Gallery', icon: '🛍️', label: 'Gallery' },
              { id: 'CBSE', icon: '📦', label: 'CBSEDisclosures' },
              { id: 'Academic', icon: '👥', label: 'Academic' },
              {id: 'sliders', icon: '🖼️', label: 'Sliders'},
              { id: 'addparent', icon: '⚙️', label: 'Add Parents' },
              { id: 'Notification', icon: '📋', label: 'Notification' }
            ].map(item => (
              <li 
                key={item.id}
                style={{
                  padding: '14px 20px',
                  cursor: 'pointer',
                  background: activeTab === item.id ? 'rgba(255,255,255,0.25)' : 'transparent',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden',
                  ':hover': {
                    background: 'rgba(255,255,255,0.15)'
                  },
                  '::after': activeTab === item.id ? {
                    content: '""',
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    height: '100%',
                    width: '4px',
                    background: 'white',
                    borderRadius: '4px 0 0 4px'
                  } : {}
                }}
                onClick={() => setActiveTab(item.id)}
              >
                <span style={{
                  fontSize: '18px',
                  transition: 'transform 0.3s ease',
                  transform: activeTab === item.id ? 'scale(1.2)' : 'scale(1)'
                }}>{item.icon}</span>
                <span style={{
                  fontWeight: activeTab === item.id ? 600 : 400,
                  transition: 'all 0.3s ease'
                }}>{item.label}</span>
                {activeTab === item.id && (
                  <span style={{
                    marginLeft: 'auto',
                    fontSize: '12px',
                    background: 'rgba(255,255,255,0.3)',
                    padding: '2px 8px',
                    borderRadius: '10px'
                  }}>Active</span>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>

      {/* Scrollable Main Content */}
      <div style={{ 
          flex: 1, 
          padding: '30px',
          marginLeft: '280px', // Match sidebar width
          overflowY: 'hidden',

       
          
      }}>
        <div style={{
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '30px',
  paddingBottom: '20px',
  borderBottom: '1px solid rgba(0,0,0,0.1)'
}}>
  <h1 style={{ 
      margin: 0,
      fontSize: '28px',
      fontWeight: 700,
      color: '#1a237e',
      position: 'relative',
      '::after': {
        content: '""',
        position: 'absolute',
        bottom: '-10px',
        left: 0,
        width: '50px',
        height: '4px',
        background: 'linear-gradient(90deg, #2874f0, #1a5dc8)',
        borderRadius: '2px'
      }
  }}>
    {activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}
  </h1>
  
  <button
    onClick={handleLogout}
    style={{
      background: 'linear-gradient(135deg, #ff5252, #ff1744)',
      color: 'white',
      border: 'none',
      padding: '10px 20px',
      borderRadius: '8px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      transition: 'all 0.3s ease',
      fontSize: '14px',
      fontWeight: 500,
      boxShadow: '0 2px 10px rgba(255, 82, 82, 0.3)',
      ':hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 15px rgba(255, 23, 68, 0.4)',
        background: 'linear-gradient(135deg, #ff1744, #ff5252)'
      }
    }}
  >
    Logout
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
      <path d="M16 17l5-5-5-5" />
      <path d="M21 12H9" />
    </svg>
  </button>
</div>

        {loading ? (
          <div style={{ 
              textAlign: 'center', 
              padding: '60px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center'
          }}>
            <div style={{
              width: '60px',
              height: '60px',
              border: '5px solid rgba(40, 116, 240, 0.2)',
              borderTopColor: '#2874f0',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              marginBottom: '20px',
              '@keyframes spin': {
                'to': { transform: 'rotate(360deg)' }
              }
            }}></div>
            <h3 style={{ color: '#555', margin: 0 }}>Loading Dashboard...</h3>
          </div>
        ) : (
          <>
            {activeTab === 'dashboard' && (
              <div>

{/* <div style={{ 
  display: 'grid', 
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', 
  gap: '20px', 
  marginBottom: '30px'
}}>
  {[
    { 
      title: 'Total Products', 
      value: stats.totalProducts, 
      icon: '🛍️', 
      color: '#2874f0',
      previous: previousStats.totalProducts
    },
    { 
      title: 'Total Orders', 
      value: stats.totalOrders, 
      icon: '📦', 
      color: '#ff9f00',
      previous: previousStats.totalOrders
    },
    { 
      title: 'Total Users', 
      value: stats.totalUsers, 
      icon: '👥', 
      color: '#fb641b',
      previous: previousStats.totalUsers
    },
    { 
      title: 'Total Revenue', 
      value: `₹${stats.revenue.toLocaleString('en-IN')}`, 
      icon: '💰', 
      color: '#8e24aa',
      previous: previousStats.revenue
    }
  ].map((stat, index) => {
    const { change, direction } = calculatePercentageChange(stat.value, stat.previous);
    const isPositive = direction === '↑';
    
    return (
      <div key={index} style={{
        background: 'linear-gradient(135deg, white 0%, #f8f9fd 100%)',
        borderRadius: '12px',
        padding: '25px',
        boxShadow: '0 5px 15px rgba(0,0,0,0.05)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'all 0.3s ease',
        position: 'relative',
        overflow: 'hidden',
        ':hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0 8px 25px rgba(0,0,0,0.1)'
        },
        '::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '5px',
          background: stat.color
        }
      }}>
        <div>
          <div style={{ 
              color: '#666', 
              fontSize: '14px',
              fontWeight: 500,
              marginBottom: '5px'
          }}>{stat.title}</div>
          <div style={{ 
              fontSize: '28px', 
              fontWeight: 'bold', 
              margin: '8px 0',
              color: '#333'
          }}>{stat.value}</div>
          <div style={{
            fontSize: '12px',
            color: '#888',
            display: 'flex',
            alignItems: 'center',
            gap: '5px'
          }}>
            <span style={{ 
                color: isPositive ? '#4CAF50' : '#F44336',
                fontWeight: 600
            }}>
              {direction} {change}% from last month
            </span>
          </div>
        </div>
        <div style={{
          width: '60px',
          height: '60px',
          borderRadius: '50%',
          background: `${stat.color}20`,
          color: stat.color,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '24px',
          transition: 'all 0.3s ease',
          ':hover': {
            transform: 'scale(1.1) rotate(10deg)'
          }
        }}>
          {stat.icon}
        </div>
      </div>
    );
  })}
</div> */}

              </div>
            )}
            {activeTab === 'Gallery' && <MediaUploader/>}
            {activeTab === 'sliders' && <AdminSlider/>}
            {activeTab === 'addparent' && <AddParentForm/>}
            {activeTab === 'CBSE' && <OrderDocumentsTable />}
            {activeTab === 'Academic' && <AcademicAdminDashboard/>}     
            {activeTab === 'Notification' && <Notification/>}
            
          </>
        )}
      </div>
      <style>{`
  .users-table-wrapper {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    max-height: 600px; /* Set maximum height for scroll */
    overflow-y: auto; /* Enable vertical scrolling */
  }

  .users-table {
    width: 100%;
    border-collapse: collapse;
    position: relative;
  }

  .users-table thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f1f5f9;
  }

  .users-table th {
    background: #f1f5f9;
    padding: 1rem 1.5rem;
    text-align: left;
    font-weight: 600;
    color: #334155;
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    position: sticky;
    top: 0;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
  }

  .users-table tbody {
    overflow-y: auto;
  }

  /* Keep existing styles, add these modifications */
  .users-table tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  .users-table td {
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #f1f5f9;
    color: #334155;
    transition: background 0.2s;
    background: white;
  }
`}</style>
    </div>
  );
};

export default AdminDashboard;














